import { Provider, ErrorBoundary } from '@rollbar/react';
import type Rollbar from 'rollbar';
import type { PropsWithChildren } from 'react';
const BROWSER_EXTENSION_URL_RE = /^(chrome|moz|safari|safari-web|ms-browser)-extension:\/\/|webkit-masked-url:\/\//;
type TStackFrame = {
  filename?: string;
};
type TTraceBody = {
  trace?: {
    frames?: TStackFrame[];
  };
  trace_chain?: Array<{
    frames?: TStackFrame[];
  }>;
};
const isBrowserExtensionFrame = (filename?: string) => Boolean(filename && BROWSER_EXTENSION_URL_RE.test(filename));
const getStackFrames = (payload: Rollbar.Dictionary): TStackFrame[] => {
  const body = payload.body as TTraceBody | undefined;
  return body?.trace?.frames ?? body?.trace_chain?.flatMap(trace => trace.frames ?? []) ?? [];
};
const hasBrowserExtensionFrames = (payload: Rollbar.Dictionary) => getStackFrames(payload).some(frame => isBrowserExtensionFrame(frame.filename));
export const rollbarConfig: Rollbar.Configuration = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
  captureUncaught: true,
  addErrorContext: true,
  captureUnhandledRejections: true,
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.NEXT_PUBLIC_APP_VERSION,
        guess_uncaught_frames: true
      }
    }
  },
  enabled: process.env.NODE_ENV !== 'development',
  checkIgnore: (_isUncaught, _args, payload) => hasBrowserExtensionFrames(payload)
};
export const RollbarProvider = ({
  children
}: PropsWithChildren) => <Provider config={rollbarConfig}>
    <ErrorBoundary>{children}</ErrorBoundary>
  </Provider>;